import { render, staticRenderFns } from "./InfusionDosingTypeSelect.vue?vue&type=template&id=172b19ec&scoped=true&"
import script from "./InfusionDosingTypeSelect.vue?vue&type=script&lang=js&"
export * from "./InfusionDosingTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172b19ec",
  null
  
)

export default component.exports